import ProductsModule from '@/modules/product';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/product/')({
  component: ProductPage,
});

function ProductPage() {
  return <ProductsModule />;
}
